import { render } from "./About.vue?vue&type=template&id=ccfab06c&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=ccfab06c&lang=css"
import "./About.vue?vue&type=style&index=1&id=ccfab06c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccfab06c"]])

export default __exports__